import { fontSizes } from '../resources/fontSizes';

const colors = {
  almostWhite: '#c9cdd9',

  bbb: '#E4E8ED',
  black: '#000000',
  blueGrey: '#2A2A34',
  blueWhiteHard: '#D6DEE8',

  cowbellAccent: '#6ac52a',
  cowbellGreen: '#bee6a2',
  cowbellLight: '#2180e2',
  cyan: '#20658c',

  error: '#ff0000',
  eggWhite: '#FDFDFE',

  dark: '#27242C',
  dark1: '#09090c',
  darkBlue: '#175595',
  darkGrey: '#1f1f29',
  darkGrey3: '#5e5e5f',
  darkGreyActive: '#444353',
  darkGreyLighter: '#26262e',
  darkGreySoft: '#9aa0ae',

  grey1: '#2a2a34',
  grey6: '#47474d',
  grey8: '#2a2c31',
  grey11: '#a3a3a6',
  greyWhite: '#9192a4',

  paleGrey: '#eff6ff',
  powderBlue: '#b4d4f5',

  ripeTomato: '#f53d00',

  tableRowDark: '#1F2833',
  tableRowLight: '#EAF8FF',
  textRed: '#fa8072',
  tomato: '#eb5e30',

  white: '#ffffff',

  critical: '#ca2b2f',
  elevated: '#fda942',
  good: '#6ac52a',
};

const fonts = {
  stackSans:
    '"Roboto", Helvetica, Arial, "Arial Unicode", "Lucida Sans Unicode", sans-serif',
};

const weights = {
  bold: 600,
};

export const commonThemeBase = {
  config: {
    colors,
    fonts,
    textSizes: { ...fontSizes },
    weights,
  },
};
